import {Component, forwardRef, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validators
} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {WidgetValidator} from '@pt/pt-models';
import {ValidatorGenerator} from '../../utils';

@Component({
  selector: 'pt-input-number',
  templateUrl: './input-number.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputNumberComponent)
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputNumberComponent),
      multi: true
    }
  ]
})
export class InputNumberComponent implements OnDestroy, OnChanges, ControlValueAccessor {

  @Input() id: string;
  @Input() inputWidth = '100%';
  @Input() validators: WidgetValidator[];
  @Input() label: string;
  @Input() fontWeightBold: boolean;
  @Input() placeholder: string;
  @Input() help: string;
  @Input() maxValue?: number;
  @Input() minValue?: number;


  public formGroup: FormGroup;
  isChanged = false;
  required: boolean;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private onChanged: (val) => void;
  private onTouched: () => void;


  ngOnChanges(changes: SimpleChanges): void {
    this.setFormGroup();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  writeValue(obj: number): void {
    this.formGroup.controls.value.setValue(obj, {emitEvent: false, onlySelf: true});
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formGroup.controls.value.disable({emitEvent: false, onlySelf: true});
    } else {
      this.formGroup.controls.value.enable({emitEvent: false, onlySelf: true});
    }
  }

  validate(value: FormControl) {
    return this.formGroup.invalid && {
      invalid: true
    };
  }

  private setFormGroup() {
    this.destroy$.next(true);
    const validator = ValidatorGenerator.generateValidator(this.validators);
    this.required = validator?.includes(Validators.required);
    this.formGroup = new FormGroup({
      value: new FormControl(null, validator)
    });

    this.formGroup.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe(t => {
      this.isChanged = t?.value !== null;
      if (this.onChanged) {
        this.onChanged(t ? t.value : t);
      }
      if (this.onTouched) {
        this.onTouched();
      }
    });
  }
}
